import firebase from "@/services/firebase";

export default firebase.firestore().collection('users');
